import { NavLink, Outlet, Link } from 'react-router';
import { useAuthUser } from '@/features/auth/AuthContext';
import { useProfile } from '@/features/auth/hooks/useProfile';
import AccessDeniedPage from './AccessDeniedPage';

const NAV_LINKS = [
  { to: '/admin', label: 'Dashboard', end: true },
  { to: '/admin/articles', label: 'Articles' },
  { to: '/admin/newsletters', label: 'Newsletters' },
  { to: '/admin/media', label: 'Media' },
  { to: '/admin/concepts', label: 'Concepts' },
  { to: '/admin/tickers', label: 'Tickers' },
];

export default function AdminLayout() {
  const { isAuthenticated, isLoading: authLoading, user, signOut } = useAuthUser();
  const { data: profile, isLoading: profileLoading } = useProfile();

  if (authLoading || profileLoading) {
    return <div style={{ padding: '40px', color: 'var(--color-text-muted)', fontSize: '14px' }}>Loading…</div>;
  }

  // ProtectedRoute handles the redirect; this is a safety net
  if (!isAuthenticated) return null;

  if (profile?.role !== 'admin') return <AccessDeniedPage />;

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <aside style={{ width: '200px', flexShrink: 0, borderRight: '1px solid var(--color-border-strong)', display: 'flex', flexDirection: 'column', padding: '24px 0' }}>
        <div style={{ padding: '0 20px 24px', borderBottom: '1px solid var(--color-border-strong)' }}>
          <Link to="/" style={{ fontFamily: "'Playfair Display', serif", fontSize: '16px', color: 'var(--color-text-primary)', textDecoration: 'none', fontWeight: 700 }}>
            AheadMetric
          </Link>
        </div>
        <nav style={{ flex: 1, padding: '16px 0' }}>
          {NAV_LINKS.map(({ to, label, end }) => (
            <NavLink key={to} to={to} end={end} style={({ isActive }) => ({
              display: 'block', padding: '8px 20px', fontSize: '13px', fontFamily: "'DM Sans', sans-serif",
              color: isActive ? 'var(--color-text-primary)' : 'var(--color-text-muted)',
              textDecoration: 'none',
              borderLeft: isActive ? '2px solid var(--color-text-primary)' : '2px solid transparent',
              fontWeight: isActive ? 500 : 400,
            })}>
              {label}
            </NavLink>
          ))}
        </nav>
        <div style={{ padding: '16px 20px 0', borderTop: '1px solid var(--color-border-strong)', fontSize: '11px', color: 'var(--color-text-muted)' }}>
          <div style={{ marginBottom: '6px', wordBreak: 'break-all' }}>{user?.email}</div>
          <button onClick={() => signOut()} style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', fontSize: '11px', color: 'var(--color-link)' }}>Sign out</button>
        </div>
      </aside>
      <main style={{ flex: 1, padding: '32px 40px', minWidth: 0 }}>
        <Outlet />
      </main>
    </div>
  );
}
